import type { Product } from '@/domains/productDiscovery/algolia/interfaces/product';
import type { Error } from '@/domains/shoppingCart/AddToCart/AddToCart.interfaces';
import { useAddedToCartModal } from '@/domains/shoppingCart/hooks/useAddedToCartModal';

export const useAddToCartState = ({
  productId,
}: Pick<Product, 'productId'>) => {
  const addToCartModal = useAddedToCartModal();
  if (
    addToCartModal?.errors.find((error: Error) => `${error.id}` === productId)
  ) {
    return 'error';
  }
  if (
    addToCartModal?.savedProductIds.find((id: number) => `${id}` === productId)
  ) {
    return 'success';
  }
  return 'available';
};
